// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getIsSwiftHybrid } from '../../../../hybridApp/hybridAppUtils';

// Components
import CollapsableTools from '../../collapsableTools/CollapsableTools';
import TextStyleRichTextToolContainer from './textStylesTool/TextStyleRichTextToolContainer';
import SubToolList from '../SubToolList';

// Constants
import {
    RICH_TEXT_TOOLS_CONFIG,
    RICH_STYLE_TOOLS,
    INLINE_STYLE_TOOLS,
    RICH_TEXT_TOOL_COLLAPSE_ORDER,
} from './richTextToolConstants';
import { CAPTION_EDITOR_KEY } from '../../../../components/caption/captionConstants';
import { CARD_TYPE } from '../../../../../common/cards/cardConstants';
import { COMMENT_THREAD_TYPE } from '../../../../../common/comments/commentConstants';
import { TASK_TYPE } from '../../../../../common/tasks/tasksConstants';
import { DOCUMENT_MODAL_EDITOR_KEY } from '../../../../element/document/modal/documentModalConstants';

const RichTextToolList = (props) => {
    const { editorKey, gridSizeName, availableHeight, unavailableHeight } = props;

    if (getIsSwiftHybrid()) return null;

    const showInlineTools =
        editorKey === CAPTION_EDITOR_KEY || editorKey === COMMENT_THREAD_TYPE || editorKey === TASK_TYPE;

    const showBlockStyleTools = editorKey === CARD_TYPE || editorKey === DOCUMENT_MODAL_EDITOR_KEY;

    if (!showBlockStyleTools && !showInlineTools) return null;

    const availableTools = showBlockStyleTools ? RICH_STYLE_TOOLS : INLINE_STYLE_TOOLS;

    return (
        <SubToolList {...props} className="RichTextToolList">
            <TextStyleRichTextToolContainer {...props} showBlockStyleTools={showBlockStyleTools} />
            <CollapsableTools
                {...props}
                toolsId="text"
                toolsConfig={RICH_TEXT_TOOLS_CONFIG}
                collapseOrder={RICH_TEXT_TOOL_COLLAPSE_ORDER}
                availableTools={availableTools}
                availableHeight={availableHeight}
                gridSizeName={gridSizeName}
                unavailableHeight={unavailableHeight}
            />
        </SubToolList>
    );
};

RichTextToolList.propTypes = {
    editorKey: PropTypes.string,
    gridSizeName: PropTypes.string,
    availableHeight: PropTypes.number,
    unavailableHeight: PropTypes.number,
};

export default RichTextToolList;
